<template>
  <v-sheet class="pb-4">
    <div class="accent-block mt-4 mb-4" v-if="afficheAideCreation">
      <p>
        Veuillez saisir les éventuels liquidateurs et apporter toute précision utile
        concernant cette dissolution.
      </p>
    </div>

    <v-row dense>
      <v-col cols="12">
        <v-textarea
          label="Observations dissolution"
          filled
          v-model="commentaireLiquidation"
          hint="Pour toute information complémentaire"
          persistent-hint
          :rules="[serverRule('liquidation.liquidation')]"
          @input="notify('liquidation.liquidation')"
          data-testid="observations-dissolution"
        />
      </v-col>
      <v-col cols="12">
        <a-plain-text-component>
          <span class="am-t2 bold"> Liquidateurs </span>
        </a-plain-text-component>
      </v-col>
      <v-col cols="12">
        <div class="d-flex justify-center">
          <v-btn data-testid="ajouter-liquidateur" @click="ajouterLiquidateur"> Ajouter un Liquidateur </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" v-for="a in tousLiquidateurs" :key="a.key">
        <a-personne-card
          :value="a"
          editable
          @supprime="supprime(a)"
          @modifie="edite(a)"
          mode="liquidateur"
        />
      </v-col>
    </v-row>
    <a-edition-personne-dialog ref="liquidateur" mode="liquidateur" />
  </v-sheet>
</template>

<script>
import makeValueData from "@/mixins/makeValueData";
import makeRules from "@/mixins/makeRules";
import ValueDataRules from "@/mixins/ValueDataRules";
import DepotMixin from "./DepotMixin";

function wrap(collection) {
  return collection || [];
}

function ajouteCollection(collection, type) {
  return (d, index) => ({
    type,
    ...d,
    collection,
    prefix: `${collection[0]}.${collection[1]}[${index}]`,
    index,
  });
}

function mapTo(src, dest) {
  src = src || {};
  const liquidateurs = src.liquidateurs || {};

  dest.commentaireLiquidation = src.commentaireLiquidation;
  dest.liquidateurs = {
    morales: wrap(liquidateurs.morales),
    physiques: wrap(liquidateurs.physiques),
  };
}

export default {
  mixins: [DepotMixin, makeValueData(mapTo), makeRules(), ValueDataRules],
  computed: {
    tousLiquidateurs() {
      return [
        ...this.liquidateurs.physiques.map(
          ajouteCollection(["liquidateurs", "physiques"], "physique")
        ),
        ...this.liquidateurs.morales.map(
          ajouteCollection(["liquidateurs", "morales"], "morale")
        ),
      ];
    },
  },

  methods: {
    resoudCollection(collection) {
      return this[collection[0]][collection[1]];
    },
    ajouterLiquidateur() {
      this.$refs.liquidateur.nouveau(valeur => {
        const maxKey = this.clefsMax(this.tousLiquidateurs);
        const collection = this.resoudCollection(["liquidateurs", valeur.type + "s"]);

        //ajout dans l'index
        const index = collection.length;

        collection.push({ ...valeur, key: maxKey + 1, index });

        this.changed();
      });
    },
    supprime(a) {
      const collection = this.resoudCollection(a.collection);
      collection.splice(a.index, 1);
      this.changed();
    },
    edite(a) {
      const index = a.index;
      const collection = this.resoudCollection(a.collection);
      this.$refs.liquidateur.edite(a, valeur => {
        collection.splice(index, 1, valeur);
        this.changed();
      });
    },
    clefsMax(collection) {
      //trouve la valeur maximam de key dans la collection
      const keys = collection.map(m => m.key);
      if (!keys.length) {
        //pas d'entrée, donc et bien c'est 0, sinon Math.max renvoi -Infinity et c'est pas ouf
        return 0;
      }
      return Math.max(...keys);
    },
  },
};
</script>
